import React, { FC } from 'react'

import { IconSoundActiveProps } from './IconSoundActive.types'
import * as Styled from './styles/IconSoundActive.style'

import { nonThemeableRules } from '../../ruleSet'

const IconSoundActive: FC<IconSoundActiveProps> = ({
  size = nonThemeableRules.defaultSize as number as IconSoundActiveProps['size'],
  isResponsive = false,
}: IconSoundActiveProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M37.684 16c4.422 4.422 4.422 11.594 0 16.016'
          stroke='#EA1A1A'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path d='M35.027 19.164a6.875 6.875 0 0 1 0 9.727' stroke='#EA1A1A' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
        <path
          d='M30.965 42.91 18.398 32.203c-1.12-.875-1.984-1.129-3.195-1.137H8.785c-2.07 0-3.75-1.68-3.75-3.75v-6.5c0-2.07 1.68-3.75 3.75-3.75h6.418c1.211 0 2.074-.25 3.195-1.132L30.965 5.148V42.91Z'
          stroke='#fff'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconSoundActive
